import $ from 'jquery';

const JS_PREFIX = 'js-language-menu';

export default {
  init() {
    const $el = $(`.${JS_PREFIX}`);

    if(!$el.length) {
      return;
    }

    const $select = $el.find(`.${JS_PREFIX}__select`);

    $select.on('change', () => {
      window.location = $select.val();
    });
  }
}
